import React from "react";

const OwnItUpTopBGElement = () => {
  return (
    <svg
      width="70"
      height="97"
      viewBox="0 0 70 97"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6476_35646)">
        <path
          d="M70 -22C70 -37.464 57.464 -50 42 -50C26.536 -50 14 -37.464 14 -22V97C44.9279 97 70 71.9279 70 41V-22Z"
          fill="white"
          fillOpacity="0.04"
        />
        <path
          d="M56 -4C56 -19.464 43.464 -32 28 -32C12.536 -32 0 -19.464 0 -4V84C30.9279 84 56 58.9279 56 28V-4Z"
          fill="white"
          fillOpacity="0.04"
        />
      </g>
      <defs>
        <clipPath id="clip0_6476_35646">
          <rect width="70" height="97" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default OwnItUpTopBGElement;
